import { Emoji } from '@components/Emoji.tsx'
import { APPS, type AppSlug } from '@config'
import { useFavicon } from '@hooks/useFavicon.ts'
import { Link } from '@router'
import styles from './AppStub.module.css'

export const AppStub = ({ slug }: { slug: AppSlug }) => {
	useFavicon(slug)
	const app = APPS.find((a) => a.slug === slug)!
	return (
		<main className={styles.screen}>
			<Link href="/" className={styles.back}>
				← Home
			</Link>
			<div className={styles.body}>
				<span className={styles.emoji}>
					<Emoji char={app.emoji} label={app.name} />
				</span>
				<h1 className={styles.title}>{app.name}</h1>
				<p className={styles.hint}>Coming in Phase 4.</p>
			</div>
		</main>
	)
}
